export const PROFILE = {
  name: 'Mario Paglia',
  role: 'Engenheiro de Software Sênior',
  company: 'CI&T',
  location: 'Valinhos, São Paulo, Brasil',
  email: 'contato@mariopaglia.dev.br',
  phone: '(11) 94841-3923',
  whatsappUrl: 'https://wa.me/5511948413923',
  linkedinUrl: 'https://www.linkedin.com/in/devmariopaglia/',
  githubUrl: 'https://github.com/mariopaglia',
  linktreeUrl: 'https://linktr.ee/devmariopaglia',
};
